import { createSource } from '@evertrue/et-flux';

export default createSource('LaunchDarklySource', {
  actions: {
    syncFlags: true,
  },

  api: {
    syncFlags(flags) {
      this.actions.syncFlags(flags);
    },
  },
});
